import { render, staticRenderFns } from "./NotasAssociadas.vue?vue&type=template&id=7c950245"
import script from "./NotasAssociadas.vue?vue&type=script&lang=js"
export * from "./NotasAssociadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports